var map = {
	"./ion-action-sheet.entry.js": [
		"6618",
		"kiosk"
	],
	"./ion-alert.entry.js": [
		"f06c1",
		"kiosk"
	],
	"./ion-app_8.entry.js": [
		"c215",
		"kiosk"
	],
	"./ion-avatar_3.entry.js": [
		"cf12",
		"kiosk"
	],
	"./ion-back-button.entry.js": [
		"4b35",
		"kiosk"
	],
	"./ion-backdrop.entry.js": [
		"429d",
		"kiosk"
	],
	"./ion-button_2.entry.js": [
		"4453",
		"kiosk"
	],
	"./ion-card_5.entry.js": [
		"070b",
		"kiosk"
	],
	"./ion-checkbox.entry.js": [
		"dfd8",
		"kiosk"
	],
	"./ion-chip.entry.js": [
		"430d",
		"kiosk"
	],
	"./ion-col_3.entry.js": [
		"6a8a",
		"kiosk"
	],
	"./ion-datetime_3.entry.js": [
		"c15b",
		"kiosk"
	],
	"./ion-fab_3.entry.js": [
		"dd47",
		"kiosk"
	],
	"./ion-img.entry.js": [
		"95887",
		"kiosk"
	],
	"./ion-infinite-scroll_2.entry.js": [
		"d1e5",
		"kiosk"
	],
	"./ion-input.entry.js": [
		"d111",
		"kiosk"
	],
	"./ion-item-option_3.entry.js": [
		"1bb3",
		"kiosk"
	],
	"./ion-item_8.entry.js": [
		"69da",
		"kiosk"
	],
	"./ion-loading.entry.js": [
		"53a5",
		"kiosk"
	],
	"./ion-menu_3.entry.js": [
		"cb00",
		"kiosk"
	],
	"./ion-modal.entry.js": [
		"1ad0",
		"kiosk"
	],
	"./ion-nav_2.entry.js": [
		"e44f",
		"kiosk"
	],
	"./ion-popover.entry.js": [
		"4285",
		"kiosk"
	],
	"./ion-progress-bar.entry.js": [
		"9b72",
		"kiosk"
	],
	"./ion-radio_2.entry.js": [
		"beb3",
		"kiosk"
	],
	"./ion-range.entry.js": [
		"719f",
		"kiosk"
	],
	"./ion-refresher_2.entry.js": [
		"0a47",
		"kiosk"
	],
	"./ion-reorder_2.entry.js": [
		"6672",
		"kiosk"
	],
	"./ion-ripple-effect.entry.js": [
		"c8da",
		"kiosk"
	],
	"./ion-route_4.entry.js": [
		"10e8",
		"kiosk"
	],
	"./ion-searchbar.entry.js": [
		"8625",
		"kiosk"
	],
	"./ion-segment_2.entry.js": [
		"0c02",
		"kiosk"
	],
	"./ion-select_3.entry.js": [
		"d25f",
		"kiosk"
	],
	"./ion-slide_2.entry.js": [
		"05dd",
		"kiosk"
	],
	"./ion-spinner.entry.js": [
		"e11b",
		"kiosk"
	],
	"./ion-split-pane.entry.js": [
		"aae8",
		"kiosk"
	],
	"./ion-tab-bar_2.entry.js": [
		"a2bb",
		"kiosk"
	],
	"./ion-tab_2.entry.js": [
		"6725",
		"kiosk"
	],
	"./ion-text.entry.js": [
		"ed3b6",
		"kiosk"
	],
	"./ion-textarea.entry.js": [
		"8798",
		"kiosk"
	],
	"./ion-toast.entry.js": [
		"c1a5",
		"kiosk"
	],
	"./ion-toggle.entry.js": [
		"bef2",
		"kiosk"
	],
	"./ion-virtual-scroll.entry.js": [
		"5fd7",
		"kiosk"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "aa55";
module.exports = webpackAsyncContext;